<template>
  <SBtn
    variant="text"
    link-medium
    class="ml-n2 justify-start"
    style="cursor:pointer !important;"
    data-testid="back-btn"
    width="150"
    @click="emits('click')"
  >
    <VIcon>{{ icons.mdiChevronLeft }}</VIcon>
    {{ text ?? $t('input.btn.back') }}
  </SBtn>
</template>


<script lang="ts" setup>
import { mdiChevronLeft } from '@mdi/js'

const icons = { mdiChevronLeft }
defineProps<{
  text?: string
}>()
const emits = defineEmits<{
  (e: 'click'): void
}>()
</script>

<style lang="scss" scoped>
</style>
